/**
 * NEXIRT Copilot — shared session-id helper (Rev 25 Phase 2 Loop B).
 *
 * Both the hero CopilotComposer and the floating ChatWidget read/write the
 * same sessionStorage key so the conversation continues seamlessly across
 * surfaces. Same key, same UUID, same DDB row in nexirt-core (`CHAT#<id>`).
 *
 * Pre-Phase-2 each surface generated its own UUID internally; Phase 2
 * centralizes here so the composer's session is what the widget continues
 * (and vice-versa).
 */

const SESSION_KEY = "nexirt.chat-session-id";

export function getOrCreateSessionId(): string {
  try {
    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) return cached;
    const fresh =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, fresh);
    return fresh;
  } catch {
    return `s-${Date.now()}`;
  }
}

export function resetSessionId(): string {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* swallow — best effort */
  }
  return getOrCreateSessionId();
}
